/**
 * Shows the sticky offer CTA on mobile when the primary card CTA
 * is no longer visible, and hides it when the blue CTA section is in view.
 */
export default class OfferPortalStickyCta {
  constructor() {
    this.isPortal = document.body.classList.contains("offer-portal");
    this.stickyCta = document.querySelector(".offer-sticky-cta");
    this.blueSection = document.getElementById(
      this.isPortal ? "offer-portal-cta" : "offer-online-cta"
    );
    this.mediaQuery = window.matchMedia("(max-width: 767.98px)");
    this.triggerPassed = false;
    this.blueSectionVisible = false;
    this.observers = [];

    if (!this.stickyCta) {
      return;
    }

    if (this.isPortal) {
      this.triggerElement = document.getElementById("offer-portal-list");
    } else {
      this.triggerElement = document.querySelector(
        "#offer-activation-card .offer-cta"
      );
    }

    if (!this.triggerElement) {
      return;
    }

    this.mediaQuery.addEventListener("change", () => this.handleMediaChange());
    this.handleMediaChange();
  }

  handleMediaChange() {
    this.disconnectObservers();

    if (!this.mediaQuery.matches) {
      this.setVisible(false);
      return;
    }

    this.setupObservers();
    this.updateVisibility();
  }

  setupObservers() {
    if (this.isPortal) {
      const sectionObserver = new IntersectionObserver(
        ([entry]) => {
          this.triggerPassed = entry.boundingClientRect.bottom <= 0;
          this.updateVisibility();
        },
        { threshold: [0, 1] }
      );

      sectionObserver.observe(this.triggerElement);
      this.observers.push(sectionObserver);
    } else {
      const ctaObserver = new IntersectionObserver(
        ([entry]) => {
          this.triggerPassed = !entry.isIntersecting;
          this.updateVisibility();
        },
        { threshold: 0 }
      );

      ctaObserver.observe(this.triggerElement);
      this.observers.push(ctaObserver);
    }

    if (this.blueSection) {
      const blueSectionObserver = new IntersectionObserver(
        ([entry]) => {
          this.blueSectionVisible = entry.isIntersecting;
          this.updateVisibility();
        },
        {
          threshold: 0,
          rootMargin: "0px 0px -20% 0px",
        }
      );

      blueSectionObserver.observe(this.blueSection);
      this.observers.push(blueSectionObserver);
    }
  }

  disconnectObservers() {
    this.observers.forEach((observer) => observer.disconnect());
    this.observers = [];
    this.triggerPassed = false;
    this.blueSectionVisible = false;
  }

  updateVisibility() {
    this.setVisible(this.triggerPassed && !this.blueSectionVisible);
  }

  setVisible(isVisible) {
    this.stickyCta.classList.toggle("is-visible", isVisible);
    document.body.classList.toggle("offer-sticky-active", isVisible);
  }
}
